/* This script reads the hidden fields in the mute liquid template for product custom measurements. Then displays the input fields in the product page if there's a match */

/* Open the modal */
const trigger = document.querySelector("#modalTrigger");
const modal = document.querySelector("#modal-1");
const confirmBtn = modal.querySelector("#modalConfirmBtn");

if (trigger) {
  trigger.addEventListener("click", function () {
    console.log("Button pressed");
    MicroModal.show("modal-1");
  });
}

if (confirmBtn) {
  confirmBtn.addEventListener("click", function () {
    console.log("Button confirm pressed");
    const fields = modal.querySelectorAll(
      ".custom-property-measurement__input"
    );
    fields.forEach((field) => {
      const inputData = field.querySelector("input");
      const inputDataValue = inputData.value;
      const inputDataName = inputData.name;

      /* Now find the same input field in the product page */
      const hiddenInput = document.querySelector(
        `.bls__product-details-infor .custom-property-measurement__input input[name="${inputDataName}"]`
      );
      if (hiddenInput) {
        hiddenInput.value = inputDataValue;
      }
    });
  });
}
